export default __webpack_public_path__ + "static/media/cain2.f21cdce5.jpg";